import { Card, CardBody, CardHeader } from "reactstrap";
import { useI18n } from "src/utils/lni18n";
import classes from "./home.module.scss"
import { useAtom } from "jotai";
import { textReadyAtom } from "src/utils/languageService";
import { currentUserAtom } from "src/services/user/userService";
import LnIcon from "src/components/LnIcon";
import { NotificationWidget } from "./NotificationsWidget";
import { notificationService, systemNotificationsAtom } from "./NotificationService";
import PageBackground from "./PageBackground";

const Home = () => {

    const { languageService: t } = useI18n();
    const [textReady] = useAtom(textReadyAtom);
    const [currentUser] = useAtom(currentUserAtom);

    const [notifications] = useAtom(systemNotificationsAtom);
    const onSetAsRead = (id: string) => {
        notificationService.setNotificationAsOld(id);
    }

    return (
        <>
            <PageBackground />
            <div className="h-100 max-col-width m-auto">
                <div className="scrollContent h-100" aria-live="polite">
                    <Card className={classes.logoCard + " big-card-box"}>
                        <CardBody >
                            <div className="text-center">
                                <img className="m-auto" src="/imgs/logo-author.svg" alt="Author logo" />
                            </div>
                            {textReady && currentUser &&
                                <div className="text-center mt-5">
                                    <div className="d-inline-block text-start ">
                                        <h4>{t.getText("welcome")}</h4>
                                        <div className="preserve-white">{t.getText("welcome.author")}</div>
                                    </div>
                                </div>
                            }

                        </CardBody>

                    </Card>




                    {textReady && currentUser && notifications && notifications.filter(n => n.Visible).length > 0 &&
                        <div className={`${classes.smallCards}`}>


                            <div className="mb-4">
                                <Card className="h-100">
                                    <CardHeader>
                                        <h4>
                                            <LnIcon className="me-3" name="bell-icon" />
                                            {t.getText('messages')}
                                        </h4>
                                    </CardHeader>
                                    <CardBody>
                                        <NotificationWidget items={notifications} onSetAsRead={onSetAsRead} />
                                    </CardBody>

                                </Card>
                            </div>

                        </div>
                    }
                </div>

            </div>

        </>
    )
}

export default Home;
